import { ActionReducerMap } from '@ngrx/store';

import { listOwnersEditorReducer } from './list-owners-editor.reducer';
import { ListOwnersState } from './list-owners.state';
import { userSearchReducer } from './user-search.reducer';

export const listOwnersReducer: ActionReducerMap<ListOwnersState> = {
  search: userSearchReducer,
  listOwnersEditor: listOwnersEditorReducer,
};
